import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AngularSplitModule } from 'angular-split';

import { AclDataModule } from '../acl-data/acl-data.module';
import { AngularMaterialModule } from '../angular-material.module';
import { BrowseComponent } from './browse/browse.component';
import { FilenetTreeComponent } from './browse/filenet-tree/filenet-tree.component';
import { BrowseDocumentsComponent } from './browse/browse-documents/browse-documents.component';
import { BrowseFoldersComponent } from './browse/browse-folders/browse-folders.component';
import { DocumentViewsModule } from '../document-views/document-views.module';
import { FolderSettingsComponent } from './folder-settings/folder-settings.component';
import { FormsModule } from '@angular/forms';
import { SharedControlsModule } from '../shared-controls/shared-controls.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowseTransactionsComponent } from './browse/browse-transactions/browse-transactions.component';
import { BatchUploadComponent } from './browse/batch-upload/batch-upload.component';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
    declarations: [
        BrowseComponent,
        BrowseComponent,
        FilenetTreeComponent,
        BrowseDocumentsComponent,
        BrowseFoldersComponent,
        FolderSettingsComponent,
        BrowseTransactionsComponent,
        BatchUploadComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        AngularMaterialModule,
        AngularSplitModule,
        AclDataModule,
        AngularMaterialModule,
        RouterModule.forChild([]),
        DocumentViewsModule,
        SharedControlsModule,
        HttpClientModule,
        FileUploadModule,
    ],
    exports: [BrowseComponent],
    entryComponents: [BatchUploadComponent],
})
export class FolderViewsModule {}
